import React from "react";

export interface DroneContextManager{
  droneID: string | null;
  setDroneID: (droneID: string | null) => void;
};

export const DroneContext = React.createContext<DroneContextManager | null>(null);
